import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { Dialog } from 'primeng/dialog';
import { RouterLink, RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SharedModule } from '../../shared-module';
import { ButtonModule } from 'primeng/button';
import { UserAuthService } from '../../services/user/user-auth.service';
import { HeaderService } from '../../services/headerService';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DashboardService } from '../../services/business/dashboard.service';


@Component({
  selector: 'app-menu',
  imports: [
    CommonModule,
    RouterLink,
    RouterModule,
    SharedModule,
    Dialog,
    ButtonModule
  ],
  templateUrl: './menu.html',
  styleUrl: './menu.scss',
})
export class Menu {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly cdRef = inject(ChangeDetectorRef);
  showCloseButton: boolean = false;
  changePasswordForm!: FormGroup;
  items: any[] = [];
  itemsHp: any[] = [];
  value: string | undefined;
  visible: boolean = false;
  iconMap: { [key: string]: string } = {
    'Switch Company': 'assets/images/switch-company.svg',
    'Switch Client': 'assets/images/switch-user.svg',
    'Switch Client Contact': 'assets/images/switch-user.svg',
    'Change Password': 'assets/images/lock-icon.svg',
    'Theme Customizer': 'assets/images/theme-icon.svg',
    'Logout': 'assets/images/logout-icon-1.svg'
  };

  /** Raw HTML string — used for *ngIf; keep dialog in DOM when closing so onHide fires. */
  guidelinesContent = '';
  guidelines: SafeHtml = '';
  private headerService = inject(HeaderService);


  showChangePasswordDialog: boolean = false;
  showDialog() { this.showChangePasswordDialog = true; }

  logo = '';
  fullName: string = '';
  companyName: string = '';

  constructor(private fb: FormBuilder,
     private router: Router, 
     private auth: UserAuthService, 
     private dashboardService: DashboardService,
     private sanitizer: DomSanitizer) { }

  ngOnInit() {
    // this.getDashboardDetails();

    if (isPlatformBrowser(this.platformId)) {
      this.logo = localStorage.getItem('logo') || '';
      this.showCloseButton = localStorage.getItem('accept_guideline') === 'true' ? true : false;
    }

    this.items = [
      { label: 'Dashboard', routerLink: '/Dashboard' },
      { label: 'Jobs', routerLink: '/Jobs', queryParams: { first: 0, rows: 10 } },
      { label: 'Tracker', routerLink: '/Tracker' },
      { label: 'Joined', routerLink: '/Joined' },
      // { label: 'Quality Score', routerLink: '/quality-score' },
      { label: 'Rewards', routerLink: '/rewards' },
      // { label: 'Leaderboard', routerLink: '/leaderboard' },
      { label: 'Badges', routerLink: '/badges' },
    ];

    this.itemsHp = [
      { label: '__profile__', custom: true },
      { label: 'Company', custom: true },
      {
        label: 'Change Password',
        svgIcon: 'lock', 
        routerLink: 'change-password'
      },
      {
        label: 'Guidelines',
        svgIcon: 'badge-check', 
      },
     

      { separator: true },
      { label: 'Logout', svgIcon: 'logout' }
    ];
    this.changePasswordForm = this.fb.group({
      currentPassword: [''],
      newPassword: [''],
      confirmPassword: ['']
    });

    this.headerService.getGuidelines().subscribe((html: string) => {
      const raw = typeof html === 'string' ? html : '';
      this.guidelinesContent = raw;
      this.guidelines = this.sanitizer.bypassSecurityTrustHtml(raw);
    });

    this.headerService.getShowGuidelines().subscribe((show: boolean) => {
      const isAlreadyDisplayed =
        !isPlatformBrowser(this.platformId) ||
        localStorage.getItem('accept_guideline') === 'true';
        this.visible = show && !isAlreadyDisplayed; 
        this.cdRef.detectChanges();
    });

    this.dashboardService.getUserDetails().subscribe((result: any) => {
      this.fullName = result.full_name;
      this.headerService.setFullName(result.full_name);
      this.companyName = result.company_name;
    });
    this.headerService.getFullName().subscribe((fullName: string) => {
      this.fullName = fullName;
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.cdRef.markForCheck());
  }

  /** Jobs stays active on list and job-details routes; other items match their path only. */
  isNavItemActive(item: { label?: string; routerLink?: string }): boolean {
    const routePath = this.router.url.split('?')[0].replace(/^\//, '');
    const linkPath = String(item.routerLink ?? '').replace(/^\//, '');

    if (item.label === 'Jobs') {
      return routePath === 'Jobs' || routePath === 'ViewJob';
    }

    return !!linkPath && routePath === linkPath;
  }



onMenuItemClick(clickedItem: any)
{
  if(!clickedItem) return;
    if(clickedItem.label === 'Guidelines'){
      this.visible = true;
    }else if(clickedItem.routerLink){
      if (clickedItem.routerLink === 'change-password') {
        this.router.navigate([clickedItem.routerLink], {
          state: { returnUrl: this.router.url },
        });
      } else {
        this.router.navigate([clickedItem.routerLink]);
      }
    }
}

  onLogout() {
   
    let login_mode = 1;
    this.auth.clearSession(login_mode).subscribe
      (
        (result: any) => {
          if (result.request_status == 0) {
          } else {
            this.headerService.setHeaderVisibility(false);
            if (isPlatformBrowser(this.platformId)) {
              localStorage.clear();
            }
            this.router.navigate(['/login']);
          }
        }
      );
  }

  

  copyCampusURL() {
    const campusUrl = window.location.origin + '/campus'; // or any logic
    navigator.clipboard.writeText(campusUrl).then(() => {
      console.log('Campus URL copied:', campusUrl);
    });
  }

  private guidelinesCloseInProgress = false;

  /** Primary close handler — fires when [(visible)] becomes false. */
  onGuidelinesVisibleChange(open: boolean): void {
    if (!open) {
      this.acceptGuidelines();
    }
  }

  /** Backup for PrimeNG onHide (after hide animation). */
  onGuidelinesDialogHide(): void {
    console.log('onGuidelinesDialogHide');
    this.acceptGuidelines();
  }

  acceptGuidelines(): void {
    if (this.guidelinesCloseInProgress) {
      return;
    }
    this.guidelinesCloseInProgress = true;
    this.headerService.setShowGuidelines(false);
    this.visible = false;
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('accept_guideline', 'true');
    }
    this.guidelinesCloseInProgress = false;
    this.showCloseButton = true;
  }

  getDashboardDetails() {
    this.dashboardService.getDashboardDetails().subscribe((result: any) => {
      console.log('getDashboardDetails');
      console.log('nav bar');
      console.log(result);
      this.visible = result.guidelines_enable == 1 ? true : false;
      this.guidelinesContent = result.guidelines;
      this.guidelines = this.sanitizer.bypassSecurityTrustHtml(result.guidelines);
      this.cdRef.detectChanges();
    });
  }
}